<template>
  <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
    <div class="close-content"><div @click="closeDetailView" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
    <article class="sub-content-wrap">
      <section class="inner-wrap">
        <div class="s-inner-wrap">
          <div v-if="getTargetItem" class="ibox-title flex-box fl-between ibox-detail-header">
            <span class="info-menu">
              <template v-if="!getTargetItem.parentObjId">{{$t('okrDetailType')}}</template>
              <template v-if="getTargetItem.parentObjId">{{$t('keyResultDetailType')}}</template>
            </span>
            <span class="info-right">{{$t('createDateString')}} : {{getTargetItem.createdAt |  preparedTime}}</span>
          </div>
          <template v-if="getTargetItem && getTargetItem.contentText">
            <div ref="detail" id="detail" class="ibox-title detail-head">
              <objective v-if="getTargetItem && getTargetItem.contentText" :itemId="this.targetItemKey" :detailView="true" :content="getTargetItem.contentText" :progress="getTargetItem.progress ? getTargetItem.progress : '0'" :setReadOnly="checkCanMoveDetailProgress" :isComplete="getTargetItem.isComplete ? true : false" v-on:set-progress="updateProgressInfo" ref="progress" :objective="false" />
              <div class="flex-display">
                <span class="info-comment-detail date-color">{{$t('startDateStr')}} : {{getTargetItem.startDate}}</span>
                <span class="info-comment-detail date-color">{{$t('dueDateStr')}} : {{getTargetItem.dueDate}}</span>
              </div>
              <div class="ibox-tools">
                <span class="info-menu"></span>
                <span class="info-right">
                </span>
              </div>
            </div>
             <div class="ibox-child public-wrap">
              <div class="row">
                <div class="form-group col-sm-12 info-status public-detail-status">
                  <div class="public-detail">
                    <div>
                      <label class="control-label status-label" for="status">{{$t('sharedOwnersStr')}}</label>
                    </div>
                  </div>
                  <div v-if="getTargetItem.sharedOwners" class="public-box">
                    <ul>
                      <li v-for="owner in getTargetSharedOwners" :key="owner.id" class="public-cell">
                        <span class="public-userimg">
                          <img v-if="owner.userInfo.userIcon" :src="owner.userInfo.userIcon" alt="image" class="img-circle">
                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                        </span>
                        <div class="public-userinfo">
                          <span class="public-username">{{owner.userInfo.userName}}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="ibox-child public-wrap">
              <div class="row">
                <div class="form-group col-sm-12 info-status public-detail-status">
                  <div class="public-detail">
                    <div>
                      <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                      <span v-if="!targetItem.limitedAccess">{{$t('allPeopleStrType')}}</span>
                      <span v-else-if="getTargetItem.limitedAccess.limitedUsers">{{$t('userBtnTile')}}</span>
                      <span v-else-if="targetLimitedGroups">{{$t('peopleGroupTileType')}}</span>
                      <span v-else-if="targetLimitedOrgs">{{$t('organizationLabelStr')}}</span>
                    </div>
                  </div>
                  <div v-if="getTargetItem.limitedAccess && getTargetItem.limitedAccess.limitedUsers" class="public-box">
                    <ul>
                      <li v-for="limited in getTargetLimitedUsers" :key="limited.id" class="public-cell">
                        <span class="public-userimg">
                          <img v-if="limited.userInfo.userIcon" :src="limited.userInfo.userIcon" alt="image" class="img-circle">
                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                        </span>
                        <div class="public-userinfo">
                          <span class="public-username">{{limited.userInfo.userName}}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="public-detail">
                    <div v-if="getTargetItem.limitedAccess && getTargetItem.limitedAccess.limitedUsers && targetLimitedGroups">
                      <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                      <span>{{$t('peopleGroupTileType')}}</span>
                    </div>
                  </div>
                  <div v-if="targetLimitedGroups" class="public-detail-group">
                    <ul>
                      <li v-for="lgroup in targetLimitedGroups" :key="lgroup.id" class="public-username">
                        <span class="public-username">{{lgroup.groupName}}</span>
                      </li>
                    </ul>
                  </div>
                  <div class="public-detail">
                    <div v-if="getTargetItem.limitedAccess && (getTargetItem.limitedAccess.limitedUsers || targetLimitedGroups)&& targetLimitedOrgs">
                      <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                      <span>{{$t('organizationLabelStr')}}</span>
                    </div>
                  </div>
                  <div v-if="targetLimitedOrgs" class="public-detail-group">
                    <ul>
                      <li v-for="(org, key) in targetLimitedOrgs" :key="org.id" class="public-username">
                        <span class="public-username">{{org.groupName}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="ib-sub-content">
              <b-tabs>
                <b-tab @click="showCommentForm" :title="$t('commentLabelTitle')">
                  <div class="panel-body">
                    <div v-if="!getTargetComments[0]" class="comment-view ibox-child"><span class="comment-text">{{$t('stillNotCommentStr')}}</span></div>
                    <div v-else class="comment-view">
                      <div v-for="obj in getTargetComments" :key="obj.id" class="ibox-child" v-if="!obj.parentId">
                        <comment-item @set-reply="setParentCommentId" :propComment="obj"/>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab @click="showRelations" :title="$t('relatedOkrType')">
                  <div class="panel-body">
                    <template v-if="!isComplete">
                      <div @click="onClickAddRelation" class="btn btn-success add-relation add-relation-item"><i class="fa fa-plus"></i>{{$t('addOkrStr')}}</div>
                    </template>
                    <div v-for="(obj, index) in getTargetRelations" :key="obj.id" v-if="obj.relationItem.type" class="ibox-child" v-observe-visibility="relationsVisibilityChanged" :accessKey="index">
                      <relation-item :itemId="obj.relationItem.key" :userId="obj.relationItem.userId" :type="obj.relationItem.type" :relationKey="obj.key" :parentType="targetType" :parentKey="targetItemKey" v-on:get-detail="getDetail"/>
                    </div>
                    <div v-if="getTargetRelations.length === 0">
                      <span class="comment-text">{{$t('notExistRelatedOkrStr')}}</span>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </template>
        </div>
      </section>
      <article v-if="isShowCommentForm" class="sub-column-comment sub-column-active">
        <section>
          <comment-form @close-event="open = false" ref="setReply" :parentItem="this.replyParent" :targetId="this.targetItemKey" :target="this.targetType" :userId="this.getUserId" :targetOwner="this.targetUser" />
        </section>
      </article>
    </article>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Objective from '@/components/Okr/Objective'
import OkrDropDown from '@/components/Okr/OkrDropDown'
import SelectDropDown from '@/components/Okr/SelectDropDown'
import CommentItem from '@/components/Comment/CommentItem'
import RelationItem from '@/components/Okr/RelationItem'
import CommentForm from '@/components/Comment/CommentForm'
import CommonJs from '@/js/common'
import moment from 'moment'

export default {
  name: 'OkrDetailView',
  mixins: [CommonJs],
  components: {
    Objective,
    SelectDropDown,
    OkrDropDown,
    CommentItem,
    RelationItem,
    CommentForm
  },
  props: {
    targetItemKey: '',
    targetType: '',
    isComplete: false,
    targetUserId: ''
  },
  data: function () {
    return {
      tag: 'progress',
      targetItem: {},
      objectiveId: '',
      relationCount: 10,
      open: false,
      progressMax: 100,
      progressMin: 0,
      replyParent: {},
      isShowCommentForm: true
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('okrs/', [
      'getIsReadRelation'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultById',
      'getCurrentKeyresults'
    ]),
    ...mapGetters('objectives/', [
      'getObjectiveById',
      'getCurrentObjectives'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId',
      'getIsReadComment'
    ]),
    ...mapGetters('groups/', [
      'getGroupsByIds'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    getTargetItem: function () {
      if (this.targetType === 'objectives') {
        this.targetItem = this.getObjectiveById(this.targetItemKey, this.targetUser)
        return this.getObjectiveById(this.targetItemKey, this.targetUser)
      } else if (this.targetType === 'keyresults') {
        this.targetItem = this.getKeyresultById(this.targetItemKey, this.targetUser)
        return this.getKeyresultById(this.targetItemKey, this.targetUser)
      }
    },
    targetLimitedGroups: function () {
      if (this.getTargetItem.limitedAccess && this.getTargetItem.limitedAccess.limitedGroups) {
        let groups = this.getGroupsByIds(Object.keys(this.getTargetItem.limitedAccess.limitedGroups))
        let groupIds = Object.keys(groups).filter(x => !groups[x].isOrganization)
        return groupIds.length > 0 ? this.getGroupsByIds(groupIds) : null
      }
      return null
    },
    targetLimitedOrgs: function () {
      if (this.getTargetItem.limitedAccess && this.getTargetItem.limitedAccess.limitedGroups) {
        let groups = this.getGroupsByIds(Object.keys(this.getTargetItem.limitedAccess.limitedGroups))
        let orgIds = Object.keys(groups).filter(x => groups[x].isOrganization)
        return orgIds.length > 0 ? this.getGroupsByIds(orgIds) : null
      }
      return null
    },
    checkCanMoveDetailProgress: function () {
      if (this.targetType === 'objectives') {
        return 'true'
      } else if (this.targetType === 'keyresults') {
        return this.targetItem.isComplete ? 'false' : 'true'
      }
    },
    getTargetRelations: function () {
      const arrayRelations = []
      const objectRelations = this.targetItem.relations
      let chkKeys = {}
      for (const key in objectRelations) {
        let chkKey = [objectRelations[key].type, objectRelations[key].userId, objectRelations[key].key].join('_')
        if (key === '.key' || chkKeys[chkKey]) { continue }
        arrayRelations.push({key: key, relationItem: objectRelations[key]})
        chkKeys[chkKey] = true
      }
      console.log('arrayRelations.slice(0, this.relationCount)', arrayRelations.slice(0, this.relationCount))
      return arrayRelations.slice(0, this.relationCount)
    },
    getTargetComments () {
      return this.getCommentsByItemId(this.targetItemKey, this.targetType)
    },
    getTargetLimitedUsers () {
      return this.getUsersByIds(Object.keys(this.targetItem.limitedAccess.limitedUsers))
    },
    getTargetSharedOwners () {
      return this.getUsersByIds(Object.keys(this.targetItem.sharedOwners).filter(userId => userId !== this.getUserId))
    },
    targetUser () {
      return this.targetUserId || this.getUserId
    }
  },
  methods: {
    ...mapActions({
      setReadTime: 'setReadTime'
    }),
    ...mapActions('okrs/', {
      setProgress: 'SET_ITEM_PROGRESS',
      addRelation: 'ADD_RELATION'
    }),
    relationsVisibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.relationCount - 1) {
        this.relationCount += 10
      }
    },
    openDetailView () {
      console.log('OkrDetailView: openDetailView:', this.isShowCommentForm)
      this.open || (this.open = true)
      this.isShowCommentForm ? this.showCommentForm() : this.showRelations()
    },
    closeDetailView () {
      this.$emit('close-detail-view')
      this.open = false
    },
    onClickAddRelation: function () {
      this.closeDetailView()
      this.$emit('open-add-relation')
    },
    updateProgressInfo: function (value) {
      value = Math.min(this.progressMax, Math.max(this.progressMin, value))
      const $t = this.$t
      const $swal = this.$swal
      $swal({
        title: $t('popTitleStrType'),
        text: $t('confirmUpdateProgressStr'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 4000
      }).then((result) => {
        if (result.value) {
          this.targetItem.progress = String(value)
          this.setProgress({
            target: this.targetType,
            id: this.targetItemKey,
            progress: String(value)
          })
        } else {
          this.$refs.progress.back(Number(this.targetItem.progress))
        }
        console.log('--2', value)
      })
    },
    setParentCommentId: function (value) {
      this.replyParent = value
      console.log('setParentCommentId = ', this.replyParent)
      this.$refs.setReply.setContentTextByParent(value.item, value.id)
    },
    getDetail: function (value) {
      console.log('objective value', value)
      let userId = value.userId
      if (this.getMetaIsDeleted(userId)) {
        return false
      }
      console.log(userId)
      let itemId = {}
      itemId[value.type] = value.itemId
      this.$router.push({ name: 'User', params: { userId: value.userId, item: itemId } })
      console.log('push success')
    },
    showCommentForm () {
      console.log('OkrDetailView: showCommentForm')
      for (let commentId in this.targetItem.comments) {
        console.log('!this.getIsReadComment', this.targetType, this.getUserId, this.targetItemKey, commentId)
        if (!this.getIsReadComment(this.targetType, this.getUserId, this.targetItemKey, commentId)) {
          this.setReadTime({
            itemType: 'comments',
            targetType: this.targetType,
            targetOwner: this.getUserId,
            targetId: this.targetItemKey,
            itemId: commentId,
            readTime: new Date().getTime()
          })
        }
      }
      this.isShowCommentForm = true
      this.$parent.isShowCommentForm = true
    },
    showRelations () {
      console.log('OkrDetailView: showRelations')
      for (let rel in this.targetItem.relations) {
        if (!this.getIsReadRelation(this.targetType, this.getUserId, this.targetItemKey, rel)) {
          this.setReadTime({
            itemType: 'relations',
            targetType: this.targetType,
            targetOwner: this.getUserId,
            targetId: this.targetItemKey,
            relationKey: rel,
            readTime: new Date().getTime()
          })
        }
      }
      this.isShowCommentForm = false
      this.$parent.isShowCommentForm = false
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    },
    lessThanHundred: function (unreadCount) {
      return unreadCount > 99 ? 99 : unreadCount
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column;
  }

  .keyResultClose .ibox-child {
    height: 0;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
    overflow:  hidden;
    border: none;
  }
  .swal2-container {
    z-index: 100000;
  }
  .fa-chevron-down{
    transition: all 0.2s ease-in-out;
  }
  .chevronUp{
    transform: rotate(180deg);
  }
  .modal-enter-active, .modal-leave-active {
    transition: all .2s ease ;
  }
  .modal-enter, .modal-leave-to {
    opacity: 0;
  }
  /* .sub-active {
    width: 100%;
  } */
  /* .ibox-child:last-of-type {
    border-top: solid 1px #e7eaec;
    border-top: 0px;
  } */
  /* .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
    border-top: 0px;
  } */
  /* .detail-head {
    height: 20vh;
    transition: 0.2s all ease-in-out;
  }
  .detail-open {
    position: absolute;
    bottom: 0;
    left: 45%;
    display: block;
    margin: 0 auto 0.5em;
  }
  .detail-active {
    height: 50vh;
  } */
</style>



// WEBPACK FOOTER //
// src/components/DetailView/OkrDetailView.vue